import {staffService} from "../services/staffService";

const state = {
  used: null,
  bundled: null,
  purchased: null,
  total: null,
}

const getters = {
  used: (state) => state.used,
  bundled: (state) => state.bundled,
  purchased: (state) => state.purchased,
  total: (state) => state.total,
}

const mutations = {
  setUsed(state, used) {
    state.used = used;
  },
  setBundled(state, bundled) {
    state.bundled = bundled;
  },
  setPurchased(state, purchased) {
    state.purchased = purchased;
  },
  setTotal(state, total) {
    state.total = total;
  },
}

const actions = {
  async loadStaffSlots({commit}, businessUid) {
    const staffSlots = await staffService.getStaffSlots(businessUid);
    if (!staffSlots || staffSlots.code === 'error' || !staffSlots.quota) return;
    commit('setUsed', staffSlots.used);
    commit('setBundled', staffSlots.quota.bundled);
    commit('setPurchased', staffSlots.quota.purchased);
    commit('setTotal', staffSlots.quota.total);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
